export const permissionsKeys = {
  page: 'micro-sites.participates-page.page-block',
  pageBlockFind: 'micro-sites.participates-page.page-block.find',
  pageBlockCreateDefault: 'micro-sites.participates-page.page-block.createDefault',
  pageBlockUpdate: 'micro-sites.participates-page.page-block.update',
  pageBlockPreview: 'micro-sites.participates-page.page-block.preview',
  pageBlockUpdateInactivate: 'micro-sites.participates-page.inactivate.page-block.update',
  pageBlockUpdateActive: 'micro-sites.participates-page.active.page-block.update',
  pageBlockRemove: 'micro-sites.participates-page.page-block.remove',
};
